import react from "react";


const ArticleSkeleton = () => {
  return (
    <div className="max-w-3xl mx-auto py-10 animate-pulse space-y-4">
      {/* Title Skeleton */}
      <div className="h-10 bg-muted rounded-md w-3/4"></div>
      
      {/* Meta info skeleton */}
      <div className="h-4 bg-muted rounded-md w-1/4"></div>
      
      <div className="space-y-3 pt-8">
        <div className="h-4 bg-muted rounded-md w-full"></div>
        <div className="h-4 bg-muted rounded-md w-full"></div>
        <div className="h-4 bg-muted rounded-md w-5/6"></div>
        <div className="h-4 bg-muted rounded-md w-4/6"></div>
      </div>
    </div>
  );
};

export default ArticleSkeleton;